import React from "react";
import { Box } from "@curves/ui-base";

const ActivityRecordCardContent = ({ children, style = undefined, className = "" }) => {
	return (
		<Box className={`activity-record-card__content ${className}`.trim()} style={style}>
			{children}
		</Box>
	);
};

export default ActivityRecordCardContent;
